export const FILTER_DELIMITER = "\\";

// TODO: Start using this constant, needs to be updated with more values
export const FILTER_CONTEXT = Object.freeze({
  campaigns: "campaigns",
  candidates: "candidates",
  projects: "projects",
  jobPipeline: "job-pipeline",
  jobApplicants: "job-applicants",
  jobForApproval: "job-for-approval",
  jobRecommendations: "job-recommendations",
  leaderboard: "leaderboard",
  search: "search",
});

export const DIVERSITY_OPTIONS = [
  {
    value: "urg",
    label: "URG",
  },
  {
    value: "women",
    label: "Women",
  },
  {
    value: "military-experience",
    label: "Military",
  },
];

export const X_FACTOR_OPTIONS = [
  // Commented out - previous values
  // {
  //   value: "has-email",
  //   label: "Has email",
  // },
  // {
  //   value: "promotion",
  //   label: "Previously promoted",
  // },
  {
    value: "top-schools",
    label: "Attended a top school",
  },
  {
    value: "is-dev-bootcamp",
    label: "Completed a dev bootcamp",
  },
  {
    value: "work-permit",
    label: "Requires a work permit",
  },
  {
    value: "is-freelancing",
    label: "Works as a freelancer",
  },
  {
    value: "is-legacy-bank",
    label: "Works at a legacy bank",
  },
  {
    value: "is-tech-outsourcing",
    label: "Works at an outsourcing firm",
  },
];

export const ORIGIN_BASE_OPTIONS = [
  { value: "extension", label: "Extension" },
  { value: "stream", label: "Stream" },
  { value: "csv", label: "CSV upload" },
];

// `value` is the wire format: matched exactly, and case-sensitively, against the
// `round` / `funding_round` strings Crunchbase supplies, so a character out of
// place silently returns no candidates. `label` is only ever displayed, so it
// can be reworded freely -- that split is the point of the pairs.
export const EMPLOYMENT_FUNDING_ROUNDS_OPTIONS = [
  { label: "Grant", value: "Grant" },
  { label: "IPO", value: "IPO" },
  { label: "Funding Round", value: "Funding Round" },
  { label: "Series A", value: "Series A" },
  { label: "Series B", value: "Series B" },
  { label: "Series C", value: "Series C" },
  { label: "Series D", value: "Series D" },
  { label: "Series E", value: "Series E" },
  { label: "Series F", value: "Series F" },
  { label: "Series G", value: "Series G" },
  { label: "Series H", value: "Series H" },
  { label: "Series I", value: "Series I" },
  { label: "Series J", value: "Series J" },
  { label: "Seed Round", value: "Seed Round" },
  { label: "Angel Round", value: "Angel Round" },
  { label: "Post-IPO Debt", value: "Post-IPO Debt" },
  { label: "Venture Round", value: "Venture Round" },
  { label: "Debt Financing", value: "Debt Financing" },
  { label: "Pre Seed Round", value: "Pre Seed Round" },
  { label: "Corporate Round", value: "Corporate Round" },
  { label: "Post-IPO Equity", value: "Post-IPO Equity" },
  { label: "Convertible Note", value: "Convertible Note" },
  { label: "Secondary Market", value: "Secondary Market" },
  { label: "Post-IPO Secondary", value: "Post-IPO Secondary" },
  { label: "Equity Crowdfunding", value: "Equity Crowdfunding" },
  { label: "Private Equity Round", value: "Private Equity Round" },
  { label: "Product Crowdfunding", value: "Product Crowdfunding" },
  { label: "Initial Coin Offering", value: "Initial Coin Offering" },
  { label: "Non Equity Assistance", value: "Non Equity Assistance" },
];

export const AVG_RECENT_TENURE_OPTIONS = [
  { label: "Very short (0-1y)", value: "very-short-0-1" },
  { label: "Short (1-3y)", value: "short-1-3" },
  { label: "Medium (3-6y)", value: "medium-3-6" },
  { label: "Long (6-10y)", value: "long-6-10" },
  { label: "Very long (10y+)", value: "very-long-10-inf" },
];

export const EARLY_AT_COMPANY_OPTIONS = [
  { label: "Very early (0-1y)", value: "very-early-0-1" },
  { label: "Early (1-3y)", value: "early-1-3" },
  { label: "Middle (3-6y)", value: "mid-3-6" },
  { label: "Late (6-10y)", value: "late-6-10" },
  { label: "Very late (10y+)", value: "very-late-10-inf" },
];

export const COMPANY_MONTHS_OPTIONS = [
  {
    label: "1 month",
    value: "1",
  },
  {
    label: "3 months",
    value: "3",
  },
  {
    label: "6 months",
    value: "6",
  },
  {
    label: "1 year",
    value: "12",
  },
  {
    label: "2 years",
    value: "24",
  },
  {
    label: "3 years",
    value: "36",
  },
  {
    label: "4 years",
    value: "48",
  },
  {
    label: "5 years",
    value: "60",
  },
  {
    label: "10 years",
    value: "120",
  },
];
